import styled, { css } from 'styled-components';

import { Breakpoint, theme } from '../layout/theme';
import { Img } from '../Image/wrappers';
import { BreakpointSize, BreakpointSizes } from './index';

type StyledImageBoxProps = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  boxWidth?: string;
  boxHeight?: string;
  breakpointSizes?: BreakpointSizes;
};

const resolveBreakpointSizeValue = (
  breakpointSize: BreakpointSize,
  propToReturn: 'height' | 'width',
) => {
  if (typeof breakpointSize === 'number') {
    return breakpointSize;
  } else {
    return breakpointSize[propToReturn];
  }
};

const generateBreakpointStyles = (breakpointSizes: BreakpointSizes) => {
  return Object.entries(breakpointSizes).map(([breakpoint, size]) => {
    return css`
      ${theme.screens[breakpoint as Breakpoint]} {
        height: ${resolveBreakpointSizeValue(size, 'height')}px;
        width: ${resolveBreakpointSizeValue(size, 'width')}px;
      }
    `;
  });
};

export const StyledImageBox = styled.div<StyledImageBoxProps>`
  position: relative;
  width: ${({ boxWidth }) => boxWidth};
  height: ${({ boxHeight }) => boxHeight};

  ${Img} {
    width: auto;
    max-width: 100%;
    max-height: 100%;
  }

  // Breakpoint sizes: height & width
  ${({ breakpointSizes }) => breakpointSizes && generateBreakpointStyles(breakpointSizes)}
`;

export type Align = 'flex-start' | 'center' | 'flex-end';

interface IInner {
  align: Align;
  alignLtSm: Align;
}

export const Inner = styled.div<IInner>`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: ${(props) => props.align};

  picture {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ${theme.screens.LtSm} {
    justify-content: ${(props) => props.alignLtSm};
  }
`;
